<template>
  <div>
    <PromptControl
      @ok="ok"
      @cancel="cancel"
      @closed="closed"
      v-bind:show="show"
      v-bind:title="lang('lbl_0000056')"
      v-bind:message="lang('lbl_0000057')"
    />
    <ContentWrapperControl>
      <div
        v-show="verify"
        class="bg-white p-4 rounded-b-lg shadow overflow-hidden"
      >
        <div
          v-text="lang('lbl_0000073')"
          class="text-sm leading-normal text-grey-darkest"
        ></div>
      </div>
      <div class="bg-white p-4 rounded-lg shadow mt-4">
        <div v-show="!verify">
          <div class="mb-3">
            <TextControl
              @typing="typing"
              v-bind:value="value"
              name="mobile"
              type="mobile"
            />
          </div>
          <div>
            <ButtonControl v-on:click="update" v-bind:disabled="!isMobileValid">
              {{ lang("lbl_0000033") }}
            </ButtonControl>
          </div>
        </div>
        <div v-show="verify">
          <OTPControl
            @success="success"
            @failed="failed"
            @showloader="showloader"
            @hideloader="hideloader"
            v-bind:type="otp.type"
            v-bind:pin="otp.pin"
            v-bind:mobile="full"
          />
        </div>
      </div>
      <PrivacyInfoControl v-show="!verify" />
    </ContentWrapperControl>
    <div v-show="verify" class="pt-2 flex justify-center items-center pb-6">
      <div
        v-on:click="editMobile"
        v-text="lang('lbl_0000293')"
        class="text-sm leading-none underline text-grey-darker font-semibold"
      ></div>
    </div>
  </div>
</template>

<script>
import { onBeforeRouteLeave } from "vue-router";
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import PrivacyInfoControl from "@/components/controls/PrivacyInfoControl.vue";
import OTPControl from "./../../components/controls/OTPControl.vue";
import PromptControl from "./../../components/controls/PromptControl.vue";
import TextControl from "./../../components/controls/TextControl.vue";
import User from "./../../services/User.js";
import mixin from "./../../mixin.js";
import OTP from "@/services/OTP";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    OTPControl,
    PromptControl,
    TextControl,
    PrivacyInfoControl,
  },
  data() {
    return {
      value: null,
      disabled: true,
      full: null,
      name: null,
      href: null,
      show: false,
      verify: false,
      hash: null,
      saving: false,
      otp: {
        type: 7,
        token: null,
        pin: null,
      },
    };
  },
  mounted() {
    this.$emit("checkauth", false);
    this.$emit("nofooter", true);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000270"),
      show: true,
      back: true,
    });

    let state = this.$store.state;
    this.value = state.enroll.mobile_no;

    onBeforeRouteLeave((to) => {
      this.href = to.fullPath;
    });
  },
  computed: {
    isMobileValid() {
      const regex = /^9\d{9}$/;
      return regex.test(this.value);
    },
  },
  methods: {
    reset() {
      this.saving = false;
      this.verify = false;
      this.hash = null;
      this.otp.token = null;
      this.otp.pin = null;
    },
    success(data) {
      let state = this.$store.state;

      this.saving = true;
      this.otp.token = data.otp_token;
      this.$emit("showloader");
      User.updateMobile(state.uuid, {
        value: this.full,
        otp_token: this.otp.token,
        otp_pin: this.otp.pin,
        update_key: this.hash,
      })
        .then(() => {
          state.info.mobile_no = this.full;
          state.enroll.mobile_no = null;
          state.otp_login = true;
          this.makeOTPLoginCookie(state.hash);
          this.$emit("success", this.lang("lbl_0000278"));
          
          if(!state.info.email){
            this.$router.push("/user/info/checklist");
            return;
          }

          if (
            state.login &&
            state.has_pin &&
            !state.pin_login &&
            (!state.config.status || (state.config.status && state.otp_login))
          ) {
            this.$router.push("/");
            return;
          }

          if (state.login && !state.has_pin) {
            this.$router.push("/user/enroll/pin");
            return;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        }).finally(() => {
          this.reset();
          this.$emit("hideloader");
        });
    },
    failed(message) {
      this.$emit("alert", {
        theme: "error",
        title: this.lang("lbl_0000034"),
        message: message,
      });
    },
    showloader() {
      this.$emit("showloader");
    },
    hideloader() {
      if (!this.saving) {
        this.$emit("hideloader");
      }
    },
    ok() {
      if (this.href != null) {
        this.$router.push(this.href);
      }
    },
    cancel() {
      this.show = false;
    },
    closed() {
      this.show = false;
    },
    typing(obj) {

      let state = this.$store.state;

      this.value = obj.value;
      state.enroll.mobile_no = this.value;
      this.full = "+63" + this.value;
    },
    update() {
      let state = this.$store.state;

      this.$emit("showloader");
      User.validateMobile(state.uuid, this.full)
        .then((response) => {
          let data = response.data.data;

          this.hash = data.hash;
          this.otp.type = data.type;
          this.otp.pin = data.pin;
          this.requestOTP();
        })
        .catch((error) => {
          this.reset();
          this.$emit("error", error);
        });
    },
    requestOTP() {
      let state = this.$store.state;

      this.$emit("showloader");
      OTP.request(
        this.otp.type,
        state.info.first_name,
        null,
        this.full,
        this.otp.pin,
      )
        .then(() => {
          this.$emit("shownavbar", {
            title: this.lang("lbl_0000270"),
            show: true,
            back: false,
          });
          this.verify = true;
        })
        .catch((error) => {
          this.$emit("failed", error.response.data.message);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
    editMobile() {
      this.$emit("shownavbar", {
        title: this.lang("lbl_0000270"),
        show: true,
        back: true,
      });
      this.verify = false;
    },
  },
  watch: {
    value(value) {
      this.full = "+63" + value;
    },
  },
};
</script>
